export default "__VITE_ASSET__CWkJkCww__"